export enum DocumentName {
	RESERVATION_AGREEMENT = 'reservation_agreement',
	RESERVATION_CONFIRM = 'reservation_confirm',
	VOUCHER = 'voucher',
}
